import API from 'constants/api';
import { getResourceDisplayValue } from 'actions/resourceActions';
import { getFormData, resToJsonHandleErrors } from 'helpers/actionHelpers';
import { removeValue, addValue, setValue } from './fieldActions';
import { getParentUri } from 'helpers/fieldHelpers';
import Predicates from 'constants/predicates';
import Types from 'constants/types';
import { createResource, editResource } from './resourceActions';

export const editDigitalContent = (resource, uri, type, action, predicate, objectUri) => {
  const formData = getFormData(resource, true);
  const file = resource.file;

  if (file) {
    formData.set('binaryfile', file, file.name);
  }

  // formBackingObject in Controller
  formData.set('uri', resource.parentUri);
  formData.set('type', type);
  formData.set('versionAction', action);

  // Editing existing content
  if (uri) {
    formData.set('contentUri', uri);
  }
  return fetch(API.DAM.EDIT_DIGITAL_CONTENT, {
    method: 'POST',
    body: formData
  }).then(resToJsonHandleErrors)
    // SPEC-38, SPEC-37 digital content has the same predicate for all types
    .then(json => getResourceDisplayValue(json.uri, Predicates.ARCHIVE.DEPICTED_OBJECT_INVERSE, predicate, objectUri));
};

export const createImage = (isPrimaryVersion, setMediaLoading) => (dispatch, getState) => {
  const predicate = Predicates.ARCHIVE.DEPICTED_OBJECT_INVERSE;
  const type = Types.ARCHIVE.IMAGE;
  const state = getState();
  const objectUri = state.object.uri;

  createResource({
    predicate,
    type,
    isPrimaryVersion,
    onSave: resource => {
      if(setMediaLoading){
        setMediaLoading(true);
      } 
      editDigitalContent(resource, null, 'image', 'alternative', type, objectUri)
        .then(value => dispatch(addValue(type, value)))
        .then(() => {if(setMediaLoading){ setMediaLoading(false);}});
    }
  })(dispatch, getState);
};

export const editImage = (index, value, isPrimaryVersion) => (dispatch, getState) => {
  const predicate = Predicates.ARCHIVE.DEPICTED_OBJECT_INVERSE;
  const type = Types.ARCHIVE.IMAGE;
  const state = getState();
  const objectUri = state.object.uri;
  
  editResource({
    predicate,
    type,
    index,
    value,
    isPrimaryVersion,
    onSave: resource => {
      editDigitalContent(resource, value.uri, 'image', 'edit_metadata', type, objectUri)
        .then(value => dispatch(setValue(type, index, value)));
    }
  })(dispatch, getState);
};

export const createAttachment = () => (dispatch, getState) => {
  const predicate = Predicates.ARCHIVE.DEPICTED_OBJECT_INVERSE;
  const type = Types.ARCHIVE.DOCUMENT;
  const state = getState();
  const objectUri = state.object.uri;

  createResource({
    predicate,
    type,
    onSave: resource => {
      editDigitalContent(resource, null, 'attachment', 'alternative', type, objectUri)
        .then(value => dispatch(addValue(type, value)));
    }
  })(dispatch, getState);
};

export const editAttachment = (index, value) => (dispatch, getState) => {
  const predicate = Predicates.ARCHIVE.DEPICTED_OBJECT_INVERSE;
  const type = Types.ARCHIVE.DOCUMENT;
  const state = getState();
  const objectUri = state.object.uri;

  editResource({
    predicate,
    type,
    index,
    value,
    onSave: resource => {
      editDigitalContent(resource, value.uri, 'attachment', 'edit_metadata', type, objectUri)
        .then(value => dispatch(setValue(type, index, value)));
    }
  })(dispatch, getState);
};

export const deleteDigitalContent = (uri, predicate, index, reason) => (dispatch, getState) => {
  const formData = new FormData();
  const parentUri = getParentUri(getState());

  formData.set('uri', parentUri);
  formData.set('contentUri', uri);
  formData.set('versionAction', 'delete');

  if (reason != null && reason) {
    formData.set('removalReason', reason);
  }

  return fetch(API.DAM.EDIT_DIGITAL_CONTENT, {
    method: 'POST',
    body: formData
  })
    .then(resToJsonHandleErrors)
    .then(res => {
      if (!res.deleted) {
        throw new Error('deleteFailed');
      }
      dispatch(removeValue(predicate, index));
    });
};
